import { holidayOn } from '@ergo/shared';
import { useSchoolHolidays } from '../holidays';
import { isValidDate } from '../time';

/**
 * Un mot quand le jour choisi tombe en vacances scolaires. Même ton que
 * `PersoWarning`, et même teinte : informatif, jamais bloquant — beaucoup de séances
 * se font à domicile, et une séance de vacances est parfaitement normale (DESIGN.md).
 */
export function HolidayHint({ date }: { date: string }) {
  const valid = isValidDate(date);
  const holiday = holidayOn(date, useSchoolHolidays(valid ? date : '', valid ? date : ''));
  if (!holiday) return null;

  return (
    <p className="note-sun" role="status">
      Vacances scolaires · {holiday.name}
    </p>
  );
}
